import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Brands/services/constants";

export const clearBrands = createAction(`${moduleSlug}/CLEAR_BRANDS`);

export const getBrands = createAction(`${moduleSlug}/GET_BRANDS`);
export const getBrandsSuccess = createAction(`${moduleSlug}/GET_BRANDS/SUCCESS`);
export const getBrandsError = createAction(`${moduleSlug}/GET_BRANDS/ERROR`);

export const getBrandByCode = createAction(`${moduleSlug}/GET_BRAND_BY_CODE`);
export const getBrandByCodeSuccess = createAction(`${moduleSlug}/GET_BRAND_BY_CODE/SUCCESS`);
export const getBrandByCodeError = createAction(`${moduleSlug}/GET_BRAND_BY_CODE/ERROR`);

export const updateBrand = createAction(`${moduleSlug}/UPDATE_BRAND`);
export const updateBrandSuccess = createAction(`${moduleSlug}/UPDATE_BRAND/SUCCESS`);
export const updateBrandError = createAction(`${moduleSlug}/UPDATE_BRAND/ERROR`);

export const createBrand = createAction(`${moduleSlug}/CREATE_BRAND`);
export const createBrandSuccess = createAction(`${moduleSlug}/CREATE_BRAND/SUCCESS`);
export const createBrandError = createAction(`${moduleSlug}/CREATE_BRAND/ERROR`);

export const setSelectedBrands = createAction(`${moduleSlug}/SET_SELECTED_BRANDS`);

export const deleteBrand = createAction(`${moduleSlug}/DELETE_BRAND`);
